export default {
  "login": "costingh",
  "id": 76535583,
  "node_id": "MDQ6VXNlcjc2NTM1NTgz",
  "avatar_url": "https://avatars.githubusercontent.com/u/76535583?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/costingh",
  "html_url": "https://github.com/costingh",
  "followers_url": "https://api.github.com/users/costingh/followers",
  "following_url": "https://api.github.com/users/costingh/following{/other_user}",
  "gists_url": "https://api.github.com/users/costingh/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/costingh/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/costingh/subscriptions",
  "organizations_url": "https://api.github.com/users/costingh/orgs",
  "repos_url": "https://api.github.com/users/costingh/repos",
  "events_url": "https://api.github.com/users/costingh/events{/privacy}",
  "received_events_url": "https://api.github.com/users/costingh/received_events",
  "type": "User",
  "site_admin": false,
  "name": null,
  "company": null,
  "blog": "",
  "location": null,
  "email": null,
  "hireable": null,
  "bio": null,
  "twitter_username": null,
  "public_repos": 11,
  "public_gists": 0,
  "followers": 0,
  "following": 1,
  "created_at": "2020-12-23T19:44:58Z",
  "updated_at": "2021-03-27T19:01:14Z"
};